// Spanish for the clock area (ClockPanel, ClockCalendar, job check-in,
// auto check-in, clock-in alerts). English text (exact) -> Spanish.
const dict = {
  // ClockPanel
  "Online": "En línea",
  "Offline": "Desconectado",
  "Accuracy": "Precisión",
  "Location sharing on": "Compartiendo ubicación",
  "{n} points waiting to upload": "{n} puntos esperando para subir",
  "Location is blocked for this app. Turn on Location for this website in your phone/browser settings.":
    "La ubicación está bloqueada para esta app. Active la Ubicación para este sitio web en la configuración de su teléfono/navegador.",
  "Locating…": "Buscando ubicación…",
  "Retry Location": "Reintentar Ubicación",
  "clock-in only allowed on site": "solo se puede marcar entrada en el sitio",
  "On site": "En el sitio",
  "Off site": "Fuera del sitio",
  "Clock In": "Marcar Entrada",
  "Clock Out": "Marcar Salida",
  "Lunch On": "Iniciar Almuerzo",
  "Lunch Off": "Terminar Almuerzo",
  "Current period": "Período actual",
  "Last period": "Período anterior",
  "1st–14th ({month} 25th Pay Day)": "Del 1 al 14 (día de pago: 25 de {month})",
  "15th–end ({month} 10th Pay Day)": "Del 15 a fin de mes (día de pago: 10 de {month})",
  "Days": "Días",
  "Hours (no lunch)": "Horas (sin almuerzo)",
  "Hours (-1h/day lunch)": "Horas (-1h/día almuerzo)",
  "Loading map…": "Cargando mapa…",
  "Fetching location…": "Obteniendo ubicación…",
  "Location not available yet.": "La ubicación aún no está disponible.",
  "You": "Usted",
  "Distance": "Distancia",
  "ETA: {n} min": "Llegada aprox.: {n} min",
  "Past Time Logs": "Registros de Tiempo",
  "Duration": "Duración",
  "Today’s Hours": "Horas de Hoy",

  // Month names (pay-day labels)
  "January": "enero",
  "February": "febrero",
  "March": "marzo",
  "April": "abril",
  "May": "mayo",
  "June": "junio",
  "July": "julio",
  "August": "agosto",
  "September": "septiembre",
  "October": "octubre",
  "November": "noviembre",
  "December": "diciembre",

  // ClockCalendar
  "Time Log Calendar": "Calendario de Horas",
  "OFF": "LIBRE",
  "Working": "Trabajando",
  "+{n} more": "+{n} más",
  "Time Logs": "Registros de Tiempo",
  "Hours Worked": "Horas Trabajadas",

  // Job check-in
  "Checked in automatically when they entered the job area":
    "Llegada registrada automáticamente al entrar al área del trabajo",
  "auto in": "llegada auto",
  "Checked in by hand from outside the job area": "Llegada registrada a mano desde fuera del área del trabajo",
  "outside fence": "fuera del área",
  "Checked in {time}": "Llegada {time}",
  "Saving…": "Guardando…",
  "Check Out": "Registrar Salida",
  "Records your arrival time and location for this job":
    "Registra su hora de llegada y ubicación para este trabajo",
  "Getting location…": "Obteniendo ubicación…",
  "Check In Again": "Registrar Llegada Otra Vez",
  "Check In": "Registrar Llegada",
  "Time on this job: {total} ({from}–{to})": "Tiempo en este trabajo: {total} ({from}–{to})",
  "Time on this job: {total} over {n} visits": "Tiempo en este trabajo: {total} en {n} visitas",
  "Checked in at": "Llegada registrada en",
  "Job": "Trabajo",
  "Since {time}": "Desde {time}",
  "{distance} from job address": "a {distance} de la dirección del trabajo",
  "Not checked in to a job. Tap Check In on a job when you arrive.":
    "No ha registrado llegada a un trabajo. Toque Registrar Llegada en un trabajo cuando llegue.",
  "Clock in for the day, then check in at each job when you arrive.":
    "Marque su entrada del día y luego registre su llegada en cada trabajo cuando llegue.",
  "Today's stops: {n} · {total} on jobs": "Paradas de hoy: {n} · {total} en trabajos",
  "In": "Llegada",
  "Out": "Salida",
  "Clock in first": "Primero marque su entrada",
  "You are not clocked in for the day. Clock in on the Home page, then check in to":
    "No ha marcado su entrada del día. Marque su entrada en la página de Inicio y luego registre su llegada a",
  "when you are on the property.": "cuando esté en la propiedad.",
  "You are checked in to another job": "Tiene llegada registrada en otro trabajo",
  "You are checked in to": "Tiene llegada registrada en",
  "Do you want to check out of that job and check in to":
    "¿Quiere registrar su salida de ese trabajo y registrar su llegada a",
  "Switching…": "Cambiando…",
  "Are you on the property already?": "¿Ya está en la propiedad?",
  "Check in when you arrive so your time and location are recorded.":
    "Registre su llegada cuando llegue para que se guarden su hora y ubicación.",
  "Yes, check me in": "Sí, registrar mi llegada",
  "Not yet": "Todavía no",

  // Auto check-in (job fences)
  "Checked in automatically at {site} ({time})": "Llegada registrada automáticamente en {site} ({time})",
  "Checked out of {site} automatically at {time}": "Salida de {site} registrada automáticamente a las {time}",
  "(estimated, the app was closed when you left)": "(estimada, la app estaba cerrada cuando se fue)",
  "Auto check-in is on for 1 job today. Keep the app open when you arrive.":
    "El registro automático de llegada está activo para 1 trabajo hoy. Mantenga la app abierta cuando llegue.",
  "Auto check-in is on for {n} jobs today. Keep the app open when you arrive.":
    "El registro automático de llegada está activo para {n} trabajos hoy. Mantenga la app abierta cuando llegue.",
  "Auto check-in is on for your jobs today. Keep the app open when you arrive.":
    "El registro automático de llegada está activo para sus trabajos hoy. Mantenga la app abierta cuando llegue.",

  // jobVisits alerts
  "another job": "otro trabajo",
  "Could not load your job check-ins.": "No se pudieron cargar sus registros de llegada.",
  "Clock in for the day first, then check in to this job.":
    "Primero marque su entrada del día y luego registre su llegada a este trabajo.",
  "You are checked in to {job}.": "Tiene llegada registrada en {job}.",
  "Do you want to check out of that job and check in to this one?":
    "¿Quiere registrar su salida de ese trabajo y registrar su llegada a este?",
  "Check-in needs your location.": "Para registrar su llegada se necesita su ubicación.",
  "Checked in. Note: you are about {m} m ({ft} ft) outside this job's check-in area. Your supervisor will see that this check-in was outside the fence.":
    "Llegada registrada. Nota: está a unos {m} m ({ft} pies) fuera del área de llegada de este trabajo. Su supervisor verá que esta llegada fue fuera del área.",
  "Checked in. Note: your phone shows you about {m} m ({mi} mi) from the job address. Your supervisor will see this.":
    "Llegada registrada. Nota: su teléfono indica que está a unos {m} m ({mi} millas) de la dirección del trabajo. Su supervisor verá esto.",
  "Check-in failed. Please try again.": "No se pudo registrar la llegada. Intente de nuevo.",
  "Check-out failed. Please try again.": "No se pudo registrar la salida. Intente de nuevo.",

  // useClockInLogic: location errors (GEO_ERROR_TEXT) and clock alerts
  "Location is blocked for this app. Turn on Location for this website in your phone/browser settings, then tap Retry Location.":
    "La ubicación está bloqueada para esta app. Active la Ubicación para este sitio web en la configuración de su teléfono/navegador y luego toque Reintentar Ubicación.",
  "Your location is unavailable. Make sure Location / GPS is turned on for your phone, then tap Retry Location.":
    "Su ubicación no está disponible. Asegúrese de que la Ubicación / GPS esté activada en su teléfono y luego toque Reintentar Ubicación.",
  "Getting your location took too long. Move near a window or outside and tap Retry Location.":
    "Obtener su ubicación tardó demasiado. Acérquese a una ventana o salga afuera y toque Reintentar Ubicación.",
  "This device or browser does not support location.": "Este dispositivo o navegador no permite usar la ubicación.",
  "Location only works on the secure (https) version of the app.":
    "La ubicación solo funciona en la versión segura (https) de la app.",
  "Unable to get location.": "No se pudo obtener la ubicación.",
  "Clock-in needs your location.": "Para marcar entrada se necesita su ubicación.",
  "You must be at {site} to clock in (within {radius}m). You are about {dist}m away.":
    "Debe estar en {site} para marcar entrada (dentro de {radius}m). Está a unos {dist}m.",
  "You are too far from the job site.": "Está demasiado lejos del sitio de trabajo.",
  "Required": "Requerido",
  "Allowed": "Permitido",
  "GPS accuracy": "Precisión del GPS",
  "Clock-in failed. Please try again.": "No se pudo marcar la entrada. Intente de nuevo.",
  "Clock-out failed: active time log not found. Please refresh and try again.":
    "No se pudo marcar la salida: no se encontró el registro de tiempo activo. Actualice la página e intente de nuevo.",
  "Active time log not found.": "No se encontró el registro de tiempo activo.",
  "Clock-out failed: clock-in time was missing. Please contact admin.":
    "No se pudo marcar la salida: falta la hora de entrada. Comuníquese con la administración.",
  "Clock-in time missing on active log.": "Falta la hora de entrada en el registro activo.",
  "Clock-out failed. Please try again.": "No se pudo marcar la salida. Intente de nuevo.",
  "Unable to fetch location.": "No se pudo obtener la ubicación.",
  "Lunch clock-out failed: active log not found. Please refresh and try again.":
    "No se pudo terminar el almuerzo: no se encontró el registro activo. Actualice la página e intente de nuevo.",
  "Active lunch log not found.": "No se encontró el registro de almuerzo activo.",
  "Lunch clock-out failed: clock-in time missing.": "No se pudo terminar el almuerzo: falta la hora de entrada.",
  "Clock-in time missing on lunch log.": "Falta la hora de entrada en el registro de almuerzo.",
};

export default dict;
